import { useGame } from "@/contexts/GameContext";
import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { modes } from "@/lib/constants";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";

export default function GameModeStep() {
  const { state, dispatch } = useGame();

  // Poprawiona funkcja - teraz używa przekazanego 'modeId'
  const selectGameMode = (modeId) => {
    console.log("Wybrano tryb gry:", modeId); // Dodaj log do debugowania
    dispatch({ type: "UPDATE_SETTINGS", payload: { gameMode: modeId } });

    // --- OPCJONALNIE: Resetowanie kroku, jeśli tryb się zmieni ---
    // Jeśli użytkownik może wracać i zmieniać tryb,
    // możesz chcieć zresetować krok do następnego po wyborze trybu,
    // aby zapewnić spójność konfiguracji.
    // dispatch({ type: "SET_CONFIG_STEP", payload: 1 }); // Wróć do kroku 1 (lub 2, jeśli 1 to GameMode)
  };

  return (
    <div className="grid gap-4">
      {/* Lepszy układ na większych ekranach */}
      {modes.map((mode) => {
        // Upewnij się, że Twoja biblioteka ikon jest poprawnie zaimportowana
        // i że `mode.icon` jest komponentem React.
        const Icon = mode.icon;
        const isSelected = state.settings.gameMode === mode.id;

        return (
          <Button
            key={mode.id}
            onClick={() => selectGameMode(mode.id)} // Przekazujemy mode.id
            size="lg"
            variant="outline"
            className={cn(
              "whitespace-normal relative bg-card/60 backdrop-blur-sm h-auto p-6 rounded-xl outline transition-all duration-200 flex flex-col items-center justify-between gap-2",
              isSelected ? "outline-primary/50" : "outline-none"
            )}
          >
            {/* Sprawdź, czy Icon jest poprawnym komponentem */}
            {Icon && <Icon className="size-7 mb-2 text-primary" />}
            <div className="font-bold text-lg">{mode.name}</div>
            <p className="text-sm font-light">
              {/* Lepszy kontrast opisu */}
              {mode.description}
            </p>

            {/* Wskaźnik zaznaczenia */}
            {isSelected && (
              <motion.div
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                className="absolute z-10 top-2 right-2 size-5 bg-primary rounded-full flex items-center justify-center" // Powiększony wskaźnik
              >
                <Check className="size-3 text-primary-foreground" />{" "}
                {/* Lepszy kontrast ikony */}
              </motion.div>
            )}
          </Button>
        );
      })}
    </div>
  );
}
